import { Injectable } from '@angular/core';
import { LoadingController, AlertController, ToastController, PopoverController, ModalController } from '@ionic/angular';
import { UserInternetDisconnectedComponent } from '../_modals/user-internet-disconnected/user-internet-disconnected.component';
import { StringConstants } from '../_constants/stringConstants';
import { EventsService } from './eventsService';
import { AppConfigService } from './appConfigService';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  loaderDisplayed = false;


  private waitMsgInstance: any;

  waitMessageHideTimeout;

  private messageSubscriptions = [];

  toastPresented = false;
  alerPresented = false;
  popoverPresented = false;

  constructor(
    private loadingController: LoadingController,
    private alertController: AlertController,
    public toastController: ToastController,
    public popoverController: PopoverController,
    private eventsService: EventsService,
    private appConfigService: AppConfigService,
    private modalController: ModalController ,
    private translate: TranslateService
  ) {

  }

  initDialogService() {
  }

  /*

   const modal = await this.popOverCntrl.create({
            component: MessageAlert,
            cssClass: options.cssClasses ? options.cssClasses : ['appFilterContainer'],
            backdropDismiss: false

        });
        modal.onDidDismiss()
            .then((result) => {
                if (options.cb) {
                    options.cb(result);
                }
                return result;
            });
        this.currentOpenModal = modal;
        return await modal.present();

   */

  async getAlertPromise(options) {
    return new Promise(async (resolve) => {
      const confirm = await this.alertController.create({
        header: options.header,
        message: options.message,
        cssClass: 'testCustom',
        buttons: [
          {
            text: options.ok,
            handler: () => {
              return resolve(true);
            },
          },
        ],
      });
      await confirm.present().then(() => {
        this.alerPresented = true;
      });
    });
  }

  async showErrorModal(options: any) {
    options = Object.assign({
      header: this.translate.instant('ERRORS.ERROR'),
      message: options.message || options.msg || '',
      cssClass: 'testCustom',
      ok: this.translate.instant('LABELS.OK')
    }, options);
    return this.hideWaitMessage().then(() => {
      return this.getAlertPromise(options);
    });
  }

  async showMessageDialog(message, options: any = {}) {
    const toast = await this.toastController.create({
      message: message,
      cssClass: 'testCustom',
      duration: options.duration || 3000,
      position: options.position || 'top',
      showCloseButton: true
    });
    toast.present().then(() => {
      this.toastPresented = true;
    });
  }

  hideMessageDialog() {
    if (this.toastPresented) {
      this.toastController.dismiss();
      this.toastPresented = false;
    }
  }

  hideAlerController() {
    if (this.alerPresented) {
      this.alertController.dismiss();
      this.alerPresented = false;
    }
  }

  hideAllDialogs() {
    try{ this.hideMessageDialog();} catch(e) {}
    try{ this.hideAlerController();} catch(e) {}
    try{ this.hideWaitMessage();} catch(e) {}
  }

  closeDialog(){
  }

  async showInfoAlert(options : any) {
    return new Promise(async (resolve) => {
      const confirm = await this.alertController.create({
        header : options.header || '',
        message: options.message || options,
        cssClass: 'testCustom',
        buttons: [
          {
            text: this.translate.instant('LABELS.OK'),
            handler: () => {
              return resolve(true);
            },
          },
        ],
      });
      await confirm.present();
      this.setFocusOnBtn('alert-button');
    });
  }

  async showConfirmDialog(options: any) {

    return new Promise(async (resolve) => {

      console.log(options);

      const confirm = await this.alertController.create({

        header: options.header || this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
        message: options.message || this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
        cssClass: options.cssCls,
        backdropDismiss: false,
        buttons: [
          {
            text: options.cancel || this.translate.instant('LABELS.CANCEL'),
            role: 'cancel',
            handler: () => {
              return resolve(false);
            },
          },
          {
            text: options.ok || this.translate.instant('LABELS.OK'),
            handler: () => {
              return resolve(true);
            },
          },
        ],
      });
      await confirm.present();
      this.setFocusOnBtn('alert-button');
    });
  }

  showWaitMessage(msg = this.translate.instant('MESSAGES.PLEASE_WAIT')) {
    this.hideAllDialogs();
    this.loaderDisplayed = true;
    clearTimeout(this.waitMessageHideTimeout);
    return this.waitMsgInstance = this.loadingController.create({
      message: msg,
      cssClass: 'testCustom',
    }).then((res) => {
      res.present().then(() => {
        if (!this.loaderDisplayed) {
          res.dismiss();
        }
        this.waitMessageHideTimeout = setTimeout(() => {
          this.hideWaitMessage()
        }, 25000);
      });;
    });
    //await this.waitMsgInstance.present();
  }

  async hideWaitMessage() {
    try {
      if (this.loaderDisplayed) {
        this.loaderDisplayed = false;
        return await this.loadingController.dismiss();
      }
    } catch (error) {
    }

  }

  async showServerError(error) {
    const modal = await this.popoverController.create({
      component: UserInternetDisconnectedComponent,
      cssClass: 'testCustom',
      componentProps: {
        error: error
      },    
      
     });
    return await modal.present();
  }

  setFocusOnBtn(className) {
    window.setTimeout(() => {
      const elements = document.getElementsByClassName(className);
      for (let i = 0; i < elements.length; i++) {
          const btn = elements[i] as HTMLElement;
          btn.focus();
      }
    }, 200);
  }

  resetPopups() {
    this.alerPresented = false;
    this.popoverPresented = false;
    this.toastPresented = false;
    this.alertController.getTop().then((exists) => {
      if (exists) {
        this.alertController.dismiss();
      }
    });
    this.popoverController.getTop().then((exists) => {
      if (exists) {
        this.popoverController.dismiss();
      }
    });
    this.toastController.getTop().then((exists) => {
      if (exists) {
        this.toastController.dismiss();
      }
    });
    this.modalController.getTop().then((exists)=>{
       if(exists){
        this.modalController.dismiss()
       }
    });
  }

}

